import React from "react";
export const AppContext = React.createContext();
export const Provider = AppContext.Provider;